/**
 * Normalizes a user-typed company domain to the bare primary domain the search
 * provider expects: strips a leading `http(s)://`, a leading `www.`, and any
 * trailing path, then lower-cases the result.
 *
 * Mirrors the backend `normalizePrimaryDomain` treatment so a pasted URL
 * (e.g. `https://www.maconia.de/about`) is stored and displayed as `maconia.de`,
 * matching how autocompleted domains already look. Returns an empty string when
 * nothing usable remains (e.g. the user typed only `www.`).
 */
export const normalizeDomainInput = (value: string): string =>
	value
		.trim()
		.replace(/^https?:\/\//i, "")
		.replace(/^www\./i, "")
		.replace(/\/.*$/, "")
		.toLowerCase();
